import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { Button } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useShallow } from "zustand/react/shallow"

import useAIQuestStore from "./questAI/hooks/useAIQuestStore"
import useQuestBoardMultiSelectStore from "./useQuestBoardMultiSelectStore"
import AnimatedStars from "../../components/animatedStars/AnimatedStars"
import useMobile from "../../hooks/useMobile"

const AddAIQuestButton = () => {
  const {
    isOpen: isQuestAIOpen,
    onOpen: onOpenQuestAI,
    onClose: onCloseQuestAI,
  } = useAIQuestStore()

  const isMobile = useMobile()
  const { t } = useTranslation()

  const { isMultiSelectMode } = useQuestBoardMultiSelectStore(
    useShallow((state) => ({ isMultiSelectMode: state.isMultiSelectMode }))
  )

  if (isMultiSelectMode) return <></>

  const toggleQuestAI = () => {
    if (isQuestAIOpen) {
      onCloseQuestAI()
    } else {
      onOpenQuestAI()
    }
  }

  return (
    <Button
      onClick={toggleQuestAI}
      style={{
        border: "none",
        background: `linear-gradient(
          90deg,
          #f47474 10%,
          #6425ed 100%
        )`,
      }}
      text={
        <FlexBox
          direction="row"
          wrap={false}
          align="center"
          gap={SPACING.space2}
        >
          {isQuestAIOpen ? (
            <FontAwesomeIcon icon={faXmark} fontSize={isMobile ? 24 : 16} />
          ) : (
            <AnimatedStars
              animate={false}
              color={JoonUIColor.icon.inverted}
              scale={0.9}
            />
          )}
          <Typography variant="bodyBold" color={JoonUIColor.icon.inverted}>
            {isQuestAIOpen ? t("JOONIPER_CLOSE") : t("JOONIPER_CREATE_WITH_AI")}
          </Typography>
        </FlexBox>
      }
    />
  )
}

export default AddAIQuestButton
